export default __webpack_public_path__ + "static/media/sendgrid-negative.e3701308.svg";